export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
};

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
};


export const debug = false;
export const test = false;

export const Server_URL_BASE = debug ? 'https://bis.com:1331' : (test ? 'https://test-bisoffice.de' : 'https://bisoffice.app');
export const Server_URL_ZK = debug ? 'https://bis.com:5252' : (test ? 'https://zeitkontrolle.test-bisoffice.de' : 'https://zeitkontrolle.bisoffice.app');
export const Server_URL = debug ? 'https://bis.com:9999' : (test ? 'https://test-bisoffice.de' : 'https://bisoffice.app');


export const Server_LOGOUT = debug ? 'https://bis.com:9999' : (test ? 'https://test-bisoffice.de' : 'https://bisoffice.app');
export const Server_URL_MAENGELMELDER = debug ? 'https://bis.com:1313' : (test ? 'https://maengelmelder.test-bisoffice.de' : 'https://maengelmelder.bisoffice.app');

//export const Server_URL = 'https://bisoffice.app';


export const Redirect_Login = debug ? 'https://bis.com:8080/#/pages/login' : (test ? 'https://test-bisoffice.de/#/pages/login' : 'https://bisoffice.app/#/pages/login');
//export const Redirect_Login = 'https://bisoffice.app/#/pages/logkin';


export const Redirect_500 = debug ? 'https://bis.com:8080/#/pages/page500' : (test ? 'https://test-bisoffice.de/#/pages/page500' : 'https://bisoffice.app/#/pages/page500');
//export const Redirect_500 = 'https://bisoffice.app/#/pages/page500';


export const Redirect_Admin = debug ? 'https://bis.com:8080/#/administration' : (test ? 'https://test-bisoffice.de/#/administration' : 'https://bisoffice.app/#/administration');
//export const Redirect_Admin = 'https://bisoffice.app/#/administration';

export const URL_BAUMKONTROLLE = debug ? 'https://baumkontrolle.bis.com:9091/#/' : (test ? 'https://baumkontrolle.test-bisoffice.de/#/' : 'https://baumkontrolle.bisoffice.app/#/');
export const URL_NUTZERVERWALTUNG = debug ? 'https://bis.com:8080/#/user_management' : (test ? 'https://test-bisoffice.de/#/user_management' : 'https://bisoffice.app/#/user_management');
export const URL_MOBILE_SETTINGS = debug ? 'https://bis.com:8080/#/mobile_settings' : (test ? 'https://test-bisoffice.de/#/mobile_settings' : 'https://bisoffice.app/#/mobile_settings');
export const URL_AUFTRAGSBUCH = debug ? 'https://auftragsbuch.bis.com:9090/#/' : (test ? 'https://auftragsbuch.test-bisoffice.de/#/' : 'https://auftragsbuch.bisoffice.app/#/');


export const HUB_SERVER = debug ? 'https://bis.com:8888' : (test ? 'https://test-bisoffice.de/hub/hub.html' : 'https://bisoffice.app/hub/hub.html');

export const Cookie_Path = debug ? '.bis.com' : (test ? '.test-bisoffice.de' : '.bisoffice.app');


export const parseTimestamp = (timestamp, format = '') => {
  if (!timestamp) return

  const date = timestamp.seconds
      ? new Date(timestamp.seconds * 1000)
      : timestamp

  if (format === 'HH:mm') {
    return `${zeroPad(date.getHours(), 2)}:${zeroPad(date.getMinutes(), 2)}`
  } else if (format === 'DD MMMM YYYY') {
    const options = { month: 'long', year: 'numeric', day: 'numeric' }
    return `${new Intl.DateTimeFormat('de-DE', options).format(date)}`
  } else if (format === 'DD.MM.YYYY') {
    const options = { month: '2-digit', year: 'numeric', day: '2-digit' }
    return `${new Intl.DateTimeFormat('de-DE', options).format(date)}`
  } else if (format === 'DD MMMM, HH:mm') {
    const options = { month: 'long', day: 'numeric' }
    return `${new Intl.DateTimeFormat('de-DE', options).format(
        date
    )}, ${zeroPad(date.getHours(), 2)}:${zeroPad(date.getMinutes(), 2)}`
  } else if (format === 'full') {
    return `${new Intl.DateTimeFormat('de-DE', { dateStyle: 'full'}).format(date)}`
  }

  return date
}


export function arrayContains(array, cond) {
  if (array === undefined || array === null || !Array.isArray(array)) {
    return false
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i] === cond) {
      return true;
    }
  }
  return false;
}
